import { Img, Text } from "components";
import { useTranslation } from "react-i18next";

const PickUpPointAddress = ({data}) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="bg-light_blue-50 flex flex-col justify-start mt-6 p-5 rounded w-full">
        <div className="flex flex-row gap-3 justify-start">
          <Img src="/images/img_info-black.svg" className="w-6 h-6" alt="info" />
          <div className="relative">
            <Text className="font-nunitoregular text-sm flex text-black-900 leading-[24px]">
              {t("theDeliveryBoyTriedToContactYouButGotNoResponseDot")}
            </Text>
            <Text className="font-nunitoregular text-sm block items-center text-black-900 leading-[24px] mb-3">
              {t("youWillHaveToPickYourOrder")}{" "}
              <Text className="font-nunitosemibold text-sm text-black-900 inline">
                {t("todayUppercase")}
              </Text>{" "}
              {t("fromTheBelowPickupPointOrElseYourOrderWillGetCancelledDot")}
            </Text>
            <Text className="font-nunitosemibold text-base flex text-black-900 leading-[24px] mb-1">
              {data?.name}
            </Text>
            <Text className="font-nunitoregular text-[12px] flex text-gray-700 leading-[24px]">
              {t("pickUpPointAddress") + ": " + data?.address}
            </Text>
          </div>
        </div>
      </div>

      {/* <div className="bg-light_blue-50 flex flex-col justify-start mt-6 p-5 rounded w-full">
        <div className="flex flex-row gap-3 justify-start">
          <Img src="/images/img_info-black.svg" className="w-6 h-6" alt="info" />
          <div className="relative">
            <Text className="font-nunitoregular text-sm block items-center text-black-900 leading-[24px] mb-3">
              {t("youWillHaveToPickYourOrder")}{" "}
              <Text className="font-nunitosemibold text-sm text-black-900 inline">
                {t("todayUppercase")}
              </Text>{" "}
              {t("fromTheBelowPickupPointOrElseYourOrderWillGetCancelledDot")}
            </Text>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default PickUpPointAddress;